import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/blog',
  title: 'Blog',
  endpoint: '/public/blog',
  breadcrumbs: [],
}
